import { defineComponent as _defineComponent } from 'vue'
import isConvertibleToNotBlankString from '@/utils/isConvertibleToNotBlankString';
import i18n from '@/i18n';

interface InputHostProps {
  label?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Input-Host',
  props: {
  label: { default: i18n.t('integrations.sources.params.host_default_label') }
},
  setup(__props) {



const hostRules = [(v: string) => isConvertibleToNotBlankString(v) || i18n.t('integrations.sources.params.missing_host_error_message')];


return { __sfc: true,hostRules, isConvertibleToNotBlankString, i18n }
}

})